import { gql } from '@apollo/client';
import { ERROR_FRAGMENT } from './fragments.js';

export const SH_AVAILABILITY_REQUEST_FRAGMENT = gql`
  fragment ShAvailabilityRequestFields on _SH_AvailabilityRequest {
    id
    clientId
    structureId
    firstName
    lastName
    email
    phone
    desiredAt
    note
    status
    notifiedAt
    createdAt
    updatedAt
  }
`;

export const CREATE_SH_PUBLIC_AVAILABILITY_REQUEST = gql`
  mutation CreateShPublicAvailabilityRequest(
    $companyname: String!
    $structureId: ID!
    $input: _SH_CreatePublicAvailabilityRequestInput!
  ) {
    _SH_createPublicAvailabilityRequest(
      companyname: $companyname
      structureId: $structureId
      input: $input
    ) {
      ok
      error {
        ...ErrorFields
      }
      request {
        ...ShAvailabilityRequestFields
      }
    }
  }
  ${SH_AVAILABILITY_REQUEST_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const GET_SH_AVAILABILITY_REQUESTS = gql`
  query GetShAvailabilityRequests($structureId: ID, $status: _SH_AvailabilityRequestStatus) {
    MDB {
      id
      _SH_ {
        id
        availabilityRequests(structureId: $structureId, status: $status) {
          ...ShAvailabilityRequestFields
        }
      }
    }
  }
  ${SH_AVAILABILITY_REQUEST_FRAGMENT}
`;

export const UPDATE_SH_AVAILABILITY_REQUEST_STATUS = gql`
  mutation UpdateShAvailabilityRequestStatus($id: ID!, $status: _SH_AvailabilityRequestStatus!) {
    _SH_updateAvailabilityRequestStatus(id: $id, status: $status) {
      ok
      error {
        ...ErrorFields
      }
      request {
        ...ShAvailabilityRequestFields
      }
    }
  }
  ${SH_AVAILABILITY_REQUEST_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const GET_SH_AVAILABLE_FIELDS_FOR_REQUEST = gql`
  query GetShAvailableFieldsForRequest($requestId: ID!) {
    MDB {
      id
      _SH_ {
        id
        availableFieldsForRequest(requestId: $requestId) {
          id
          name
          type
          slotDuration
          structureId
        }
      }
    }
  }
`;

export const CONFIRM_SH_AVAILABILITY_REQUEST_WITH_RESERVATION = gql`
  mutation ConfirmShAvailabilityRequestWithReservation($id: ID!, $fieldId: ID!) {
    _SH_confirmAvailabilityRequestWithReservation(id: $id, fieldId: $fieldId) {
      ok
      error {
        ...ErrorFields
      }
      request {
        ...ShAvailabilityRequestFields
      }
    }
  }
  ${SH_AVAILABILITY_REQUEST_FRAGMENT}
  ${ERROR_FRAGMENT}
`;
